import React, { createContext, useContext, useReducer } from "react";
import NotificationAlert from "react-notification-alert";

const NotificationContext = createContext();

const initialState = {
  notificationRef: null,
  createNotification: null,
};

function NotificationProvider({ children }) {
  const notificationAlertRef = React.useRef(null);
  const [notificationRefState, setNotificationRefState] = React.useState(null);

  const createNotification = ({ type, message, location }) => {
    const options = {
      place: location || "tr",
      message: message,
      type: type || "primary",
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  React.useEffect(() => {
    if (!notificationAlertRef.current) {
      return;
    }

    setNotificationRefState(notificationAlertRef.current);
  }, []);

  return (
    <>
      <NotificationAlert ref={notificationAlertRef} />
      <NotificationContext.Provider
        value={{ notificationRefState, createNotification }}
      >
        {children}
      </NotificationContext.Provider>
    </>
  );
}

function useNotificationContext() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error("useCount must be used within a CountProvider");
  }
  return context;
}

export { NotificationProvider, useNotificationContext };
